import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="hero" className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20anime%20style%20illustration%20of%20a%20mother%20gently%20holding%20her%20baby%20with%20soft%20breastfeeding%20theme%20surrounded%20by%20floating%20pastel%20hearts%20and%20flowers%20dreamy%20atmosphere%20with%20warm%20peach%20and%20cream%20tones%20soft%20watercolor%20texture%20Japanese%20manga%20aesthetic%20gentle%20lighting%20peaceful%20maternal%20scene&width=1800&height=1200&seq=hero-bg-main&orientation=landscape"
          alt="奶水动漫 - 母婴哺乳主题动漫平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
            奶水动漫
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-3 font-heading">
            {siteInfo.tagline}
          </p>
          <p className="text-sm md:text-base text-white/75 mb-8 max-w-xl mx-auto leading-relaxed">
            {siteInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#categories"
              className="px-7 py-3 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap text-sm cursor-pointer"
            >
              开始探索
            </a>
            <a
              href="#featured"
              className="px-7 py-3 bg-white/20 backdrop-blur-sm text-white font-medium rounded-full hover:bg-white/30 transition-colors whitespace-nowrap text-sm cursor-pointer border border-white/30"
            >
              热门推荐
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}